const configUrl = {
	// 开发环境代理
	Base_dev_URL: '/',
	// 生产环境-测试线
	// Base_pro_URL: 'https://api.digital.bancoulm.com',
  // 生产环境-正式线
  Base_pro_URL: 'https://api.digital.bancou.com',
}
export default configUrl
